<label class="p-float-label">{{ label }}</label>
<ng-content></ng-content>
